import React, {Component, Fragment} from 'react';
import { withTranslation } from 'react-i18next';
import { Field } from "formik";
import {SelectField, YesNoRadio} from "../../Fields";
import _ from "lodash";

class PoliticianForm extends Component {
     constructor(props)
    {
        super(props);

        this.state = {
            classifiers: null,
        };

         axios.get('/api/process/' + props.applicationToken + '/get_classifiers').then(
            data => {
                let result = data.data;
                this.setState({classifiers: result})
            });
    }

    getCountryOptions = () => {
        let countries = [
            "Andora",
            "Jungtiniai Arabų Emyratai",
            "Afganistanas",
            "Antigva ir Barbuda",
            "Albanija",
            "Armėnija",
            "Angola",
            "Antarktis",
            "Argentina",
            "Amerikos Samoa",
            "Austrija",
            "Australija",
            "Aruba",
            "Azerbaidžanas",
            "Bosnija ir Hercegovina",
            "Barbadosas",
            "Bangladešas",
            "Belgija",
            "Burkina Fasas",
            "Bulgarija",
            "Bahreinas",
            "Burundis",
            "Beninas",
            "Sen Bartelemi",
            "Bermuda",
            "Brunėjaus Darusalamas",
            "Bolivijos Daugiatautė Valstybė",
            "Boneras, Sint Eustatijus ir Saba",
            "Brazilija",
            "Bahamos",
            "Butanas",
            "Buvė Sala",
            "Botsvana",
            "Baltarusija",
            "Belizas",
            "Kanada",
            "Kokosų (Kilingo) Salos",
            "Kongo Demokratinė Respublika",
            "Centrinės Afrikos Respublika",
            "Kongas",
            "Šveicarija",
            "Dramblio Kaulo Krantas",
            "Kuko Salos",
            "Čilė",
            "Kamerūnas",
            "Kinija",
            "Kolumbija",
            "Kosta Rika",
            "Kuba",
            "Žaliasis Kyšulys",
            "Kiurasao",
            "Kalėdų Sala",
            "Kipras",
            "Čekija",
            "Vokietija",
            "Džibutis",
            "Danija",
            "Dominika",
            "Dominikos Respublika",
            "Alžyras",
            "Ekvadoras",
            "Estija",
            "Egiptas",
            "Vakarų Sachara",
            "Eritrėja",
            "Ispanija",
            "Etiopija",
            "Suomija",
            "Fidžis",
            "Folklando Salos",
            "Mikronezijos Federacinės Valstijos",
            "Farerų Salos",
            "Prancūzija",
            "Gabonas",
            "Jungtinė Karalystė",
            "Grenada",
            "Gruzija",
            "Gana",
            "Gibraltaras",
            "Grenlandija",
            "Gambija",
            "Gvinėja",
            "Pusiaujo Gvinėja",
            "Graikija",
            "Pietų Džordžijos ir Pietų Sandvičo Salos",
            "Gvatemala",
            "Guamas",
            "Bisau Gvinėja",
            "Gajana",
            "Honkongas",
            "Herdas ir Makdonaldas",
            "Hondūras",
            "Kroatija",
            "Haitis",
            "Vengrija",
            "Indonezija",
            "Airija",
            "Izraelis",
            "Indija",
            "Indijos Vandenyno Britų Sritis",
            "Irakas",
            "Irano Islamo Respublika",
            "Islandija",
            "Italija",
            "Jamaika",
            "Jordanija",
            "Japonija",
            "Kenija",
            "Kirgizijos Respublika",
            "Kambodža",
            "Kiribatis",
            "Komorai",
            "Sent Kitsas ir Nevis",
            "Korėjos Liaudies Demokratinė Respublika",
            "Korėjos Respublika",
            "Kuveitas",
            "Kaimanų Salos",
            "Kazachstanas",
            "Laoso Liaudies Demokratinė Respublika",
            "Libanas",
            "Sent Lusija",
            "Lichtenšteinas",
            "Šri Lanka",
            "Liberija",
            "Lesotas",
            "Lietuva",
            "Liuksemburgas",
            "Latvija",
            "Libija",
            "Marokas",
            "Moldovos Respublika",
            "Juodkalnija",
            "Madagaskaras",
            "Maršalo Salos",
            "buvusioji Jugoslavijos Respublika Makedonija",
            "Malis",
            "Mianmaras",
            "Mongolija",
            "Makao",
            "Marianos Šiaurinės Salos",
            "Mauritanija",
            "Montseratas",
            "Malta",
            "Mauricijus",
            "Maldyvai",
            "Malavis",
            "Meksika",
            "Malaizija",
            "Mozambikas",
            "Namibija",
            "Naujoji Kaledonija",
            "Nigeris",
            "Norfolko Sala",
            "Nigerija",
            "Nikaragva",
            "Nyderlandai",
            "Norvegija",
            "Nepalas",
            "Nauru",
            "Niujė",
            "Naujoji Zelandija",
            "Omanas",
            "Panama",
            "Peru",
            "Prancūzijos Polinezija",
            "Papua Naujoji Gvinėja",
            "Filipinai",
            "Pakistanas",
            "Lenkija",
            "Sen Pjeras ir Mikelonas",
            "Pitkernas",
            "Okupuotoji Palestinos Teritorija",
            "Portugalija",
            "Palau",
            "Paragvajus",
            "Kataras",
            "Rumunija",
            "Rusijos Federacija",
            "Ruanda",
            "Saudo Arabija",
            "Saliamono Salos",
            "Seišeliai",
            "Sudanas",
            "Švedija",
            "Singapūras",
            "Šv. Elenos, Dangun Žengimo ir Tristano da Kunjos Salos",
            "Slovėnija",
            "Slovakija",
            "Siera Leonė",
            "San Marinas",
            "Senegalas",
            "Somalis",
            "Surinamas",
            "Pietų Sudanas",
            "San Tomė ir Prinsipė",
            "Salvadoras",
            "Sint Martenas (Nyderlandų dalis)",
            "Sirijos Arabų Respublika",
            "Svazilandas",
            "Terkso ir Kaikoso Salos",
            "Čadas",
            "Prancūzijos Pietų Sritys",
            "Togas",
            "Tailandas",
            "Tadžikistanas",
            "Tokelau",
            "Rytų Timoras",
            "Turkmėnistanas",
            "Tunisas",
            "Tonga",
            "Turkija",
            "Trinidadas ir Tobagas",
            "Tuvalu",
            "Taivanas",
            "Tanzanijos Jungtinė Respublika",
            "Ukraina",
            "Uganda",
            "Jungtinių Valstijų Mažosios Tolimosios Salos",
            "Jungtinės Valstijos",
            "Urugvajus",
            "Uzbekistanas",
            "Šventasis Sostas (Vatikano Miesto Valstybė)",
            "Sent Vinsentas ir Grenadinai",
            "Venesuelos Bolivaro Respublika",
            "Didžiosios Britanijos Mergelių Salos",
            "Jungtinių Valstijų Mergelių Salos",
            "Vietnamas",
            "Vanuatu",
            "Volisas ir Futūna",
            "Samoa",
            "Seuta",
            "Kosovas",
            "Melilja",
            "Serbija",
            "Jemenas",
            "Majotas",
            "Pietų Afrika",
            "Zambija",
            "Zimbabvė"
        ];

        let result = {};
        countries.forEach((item) => {
            result[item] = item;
        });

        return result;
    };

    changePoliticianRelationship = (event) => {
        let props = this.props;
        props.setFieldValue(props.type + '.politician_me', event.target.attributes['data-part'].value === 'politician_me');
        props.setFieldValue(props.type + '.politician_associate', event.target.attributes['data-part'].value === 'politician_associate');
        props.setFieldValue(props.type + '.politician_family', event.target.attributes['data-part'].value === 'politician_family');
    };

    render() {
        let props = this.props;

        return(
            <Fragment>
                <div className="col-12">
                    <YesNoRadio label={props.t('forms.are_you_a_politician')}
                                name={props.type + '.is_politician'}
                                {...props}
                    />
                </div>

                {props.values[props.type].is_politician ?
                    <div className="container mt-3">

                        <div className="row mt-4">
                            <div className="form-group col-md-6 col-lg-6">
                                <SelectField
                                    options={this.state.classifiers}
                                    name={props.type+".pep_position_type"}
                                    id={props.type+"_pep_position_type"}
                                    label={props.t('forms.politician.pep_position_type')}
                                    {...props}
                                />
                            </div>


                            <div className="form-group col-md-6 col-lg-6">
                                <SelectField
                                    options={this.getCountryOptions()}
                                    name={props.type+".country"}
                                    id={props.type+"_country"}
                                    label={props.t('forms.politician.country')}
                                    {...props}
                                />
                            </div>
                            <div className="form-group col-md-6 col-lg-6">
                                <label htmlFor={props.type+"_institution"}>{ props.t('forms.politician.institution') }</label>
                                <Field type="text"
                                       name={props.type+".institution"}
                                       id={props.type+"_institution"}
                                       className={'form-control' + (props.errors[props.type+'.institution'] && props.touched[props.type].institution ? ' is-invalid' : '')}
                                />
                                <div className="invalid-feedback">{props.errors[props.type+'.institution']}</div>
                            </div>
                            <div className="form-group col-md-6 col-lg-6">
                                <label htmlFor={props.type+"_position"}>{ props.t('forms.politician.position') }</label>
                                <Field type="text"
                                       name={props.type+".position"}
                                       id={props.type+"_position"}
                                       className={'form-control' + (props.errors[props.type+'.position'] && props.touched[props.type].position ? ' is-invalid' : '')}
                                />
                                <div className="invalid-feedback">{props.errors[props.type+'.position']}</div>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-12">
                                <div className="mb-2">{ props.t('forms.politician.describe_relationship')}</div>
                                <div className="d-flex">
                                    <div className="form-group mr-4">
                                        <div className="custom-control custom-radio">
                                            <input type="radio"
                                                   id={props.type + '.politician_me'}
                                                   name={props.type + '.politician_me'}
                                                   checked={props.values[props.type].politician_me}
                                                   data-part={'politician_me'}
                                                   className="custom-control-input"
                                                   onChange={this.changePoliticianRelationship}
                                            />
                                            <label className="custom-control-label"
                                                   htmlFor={props.type + '.politician_me'}>
                                                { props.t('forms.politician.politician_me')}
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group mr-4">
                                        <div className="custom-control custom-radio">
                                            <input type="radio"
                                                   id={props.type + '.politician_family'}
                                                   name={props.type + '.politician_family'}
                                                   checked={props.values[props.type].politician_family}
                                                   data-part={'politician_family'}
                                                   className="custom-control-input"
                                                   onChange={this.changePoliticianRelationship}
                                            />
                                            <label className="custom-control-label"
                                                   htmlFor={props.type + '.politician_family'}>
                                                { props.t('forms.politician.politician_family') }
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="custom-control custom-radio">
                                            <input type="radio"
                                                   id={props.type + '.politician_associate'}
                                                   name={props.type + '.politician_associate'}
                                                   checked={props.values[props.type].politician_associate}
                                                   data-part={'politician_associate'}
                                                   className="custom-control-input"
                                                   onChange={this.changePoliticianRelationship}

                                            />
                                            <label className="custom-control-label"
                                                   htmlFor={props.type + '.politician_associate'}>
                                                { props.t('forms.politician.politician_associate') }
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {! props.values[props.type].politician_me ?
                            <div className="form-group col-md-6 col-lg-6">
                                <label htmlFor={props.type + "_full_name"}>{props.t('forms.politician.full_name')}</label>
                                <Field type="text"
                                       name={props.type + ".full_name"}
                                       id={props.type + "_full_name"}
                                       className={'form-control' + (props.errors[props.type + '.full_name'] && props.touched[props.type].full_name ? ' is-invalid' : '')}
                                />
                                <div className="invalid-feedback">{props.errors[props.type + '.full_name']}</div>
                            </div>
                            :
                            ''
                        }
                    </div>
                    : ''}
            </Fragment>
        );
    }
}

export default withTranslation()(PoliticianForm);
